import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { Home, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';

export const Footer = () => {
  const { t, language } = useLanguage();

  const cities = ['Alger', 'Oran', 'Béjaïa', 'Tizi Ouzou', 'Annaba'];

  return (
    <footer className="bg-blue-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About */}
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                <Home className="w-6 h-6 text-blue-900" />
              </div>
              <div className="flex flex-col">
                <span className="font-manrope font-bold text-xl text-white leading-none">Beytam</span>
                <span className="text-xs text-blue-200 font-arabic">بيتم</span>
              </div>
            </Link>
            <p className="text-sm text-blue-200 leading-relaxed">
              {t('footer_about_text')}
            </p>
            <div className="flex items-center gap-4 pt-2">
              <a href="#" className="text-blue-200 hover:text-white transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-blue-200 hover:text-white transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-blue-200 hover:text-white transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-blue-200 hover:text-white transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-manrope font-semibold text-lg mb-4">{t('footer_services')}</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/search?transaction_type=vente" className="text-sm text-blue-200 hover:text-white transition-colors">
                  {t('search_buy')}
                </Link>
              </li>
              <li>
                <Link to="/search?transaction_type=location" className="text-sm text-blue-200 hover:text-white transition-colors">
                  {t('search_rent')}
                </Link>
              </li>
              <li>
                <Link to="/add-property" className="text-sm text-blue-200 hover:text-white transition-colors">
                  {t('nav_post_ad')}
                </Link>
              </li>
              <li>
                <Link to="/cities" className="text-sm text-blue-200 hover:text-white transition-colors">
                  {t('nav_price_map')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Cities */}
          <div>
            <h3 className="font-manrope font-semibold text-lg mb-4">{t('nav_cities')}</h3>
            <ul className="space-y-3">
              {cities.map((city) => (
                <li key={city}>
                  <Link
                    to={`/cities/${city.toLowerCase()}`}
                    className="text-sm text-blue-200 hover:text-white transition-colors flex items-center gap-2"
                  >
                    <MapPin className="w-3 h-3" />
                    {city}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-manrope font-semibold text-lg mb-4">{t('footer_contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm text-blue-200">
                <MapPin className="w-4 h-4 text-rose-400" />
                {language === 'fr' ? 'Alger, Algérie' : 'الجزائر العاصمة، الجزائر'}
              </li>
              <li className="flex items-center gap-3 text-sm text-blue-200">
                <Mail className="w-4 h-4 text-rose-400" />
                beytam.immo@gmail.com
              </li>
              <li className="flex items-center gap-3 text-sm text-blue-200">
                <Phone className="w-4 h-4 text-rose-400" />
                +213 XX XX XX XX
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-blue-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-blue-200">
            <p>© 2024 Beytam. {t('footer_rights')}.</p>
            <div className="flex items-center gap-6">
              <a href="#" className="hover:text-white transition-colors">
                {language === 'fr' ? 'Politique de confidentialité' : 'سياسة الخصوصية'}
              </a>
              <a href="#" className="hover:text-white transition-colors">
                {language === 'fr' ? 'CGU' : 'شروط الاستخدام'}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
